/**************************************
 ** AtlasViewerConstants
 *
 *  Container class for various constants used throughout the player
 ***************************************/
define('atlas/AtlasConstants', [], function() {
    'use strict';

    function AtlasViewerConstants() {
        //there is a better way - update this once zookeeper is up
        this.IS_DEV_ENVIRONMENT = true;

        //all possible latitude markers
        this.latitudeMarkers = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P',
                'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'ZA', 'ZB', 'ZC', 'ZD', 'ZE',
                'ZF', 'ZG', 'ZH', 'ZI', 'ZJ', 'ZK', 'ZL', 'ZM', 'ZN', 'ZO', 'ZP', 'ZQ', 'ZR',
                'ZS', 'ZT', 'ZU', 'ZV', 'ZW', 'ZX', 'ZY', 'ZZ'
        ];
        //all possible longitude markers
        this.longitudeMarkers = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13',
                '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26',
                '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39',
                '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52'
        ];

        //used to set the thresholdType of the player
        //  immediate - change as soon as the boundary line is crossed
        this.THRESHOLD_IMMEDIATE = 0;
        //  static - change based on static threshold (# of pixels) of being in the new quadrant
        this.THRESHOLD_STATIC = 1;
        //  adaptive - change based on a percentage area of being in the new quadrant (should help with smaller areas
        //    near the poles)
        this.THRESHOLD_ADAPTIVE = 2;
        //  dynamic - not used
        this.THRESHOLD_DYNAMIC = 3;

        //set the various logging flags that may be bitwise ORed, e.g., LOGGING_ERROR|LOGGING_TOUCH would give you
        //all errors and all touch events

        this.LOGGING_NONE = 0x00000;
        this.LOGGING_ALL = 0xFFFFF;
        this.LOGGING_DEBUG = 0x00001;
        this.LOGGING_INFO = 0x00010;
        this.LOGGING_ERROR = 0x00100;
        this.LOGGING_TOUCH = 0x01000;
        this.LOGGING_MOUSE = 0x02000;
        this.LOGGING_LOAD = 0x04000;
        this.LOGGING_PROGRESS = 0x08000;
        this.LOGGING_RENDER = 0x10000;
        this.LOGGING_PROJECTOR = 0x20000;
        this.LOGGING_RENDER1 = 0x40000;
        this.LOGGING_CAMERA = 0x80000;

        //default to no logging
        this.logging = this.LOGGING_NONE;

        //ability to set a redirect for logging
        this._logCallback = null;

        this.ANIMATION_FRAMES_PER_SECOND = 20;

        //priority load the longitudes that bisect the longest span of unloaded longitudes
        this.USE_BISECT_LONGITUDES = true;

        //support retina displays
        this.SUPPORT_RETINA_DISPLAYS = true;

        //maximum span of longitudes before animation is enabled
        this.MAX_LONGITUDE_SPAN_FOR_ANIMATION = 2;

        //how long to force canvas refresh when initial loading and changing configurator
        this.LOADING_FORCE_CANVAS_REFRESH_DURATION = 2000;
        //force refresh until user interacts with it
        this.FORCE_CANVAS_REFRESH_UNTIL_MOVED = -1;

        //how many items we should look back to determine the average loading time
        this.LOADING_ANALYSIS_WINDOW = 32;

        //how many images to load in a batch
        this.BATCH_SIZE = 16;
    }

    AtlasViewerConstants.prototype.setLogRedirect = function(callback) {
        this._logCallback = callback;
    };

    //TODO this is kind of a weird pattern
    //create an instances of the Constants that can be used across the components of the player
    return new AtlasViewerConstants();
});
